/** Metadata-only entity references (not rendered in visible UI). */
export const scamatrix = {
    name: "ScaMatrix",
    url: "https://scamatrix.com",
    description:
        "AI-powered threat intelligence lookup for indicators of compromise, including URLs, IPs, domains, emails, and file hashes.",
    status: "beta",
    owner: "Mark Liapustin (clizSec)",
} as const;

export const clizsec = {
    name: "Mark Liapustin (clizSec)",
    url: "https://www.clizsec.com",
    canonicalEnglish: "https://www.clizsec.com/en",
} as const;

export const webioc = {
    name: "WebIOC by ScaMatrix",
    chromeWebStoreUrl: "https://chromewebstore.google.com/detail/kecdebdfinlfcbobnklcihofifnhbcld",
    privacyUrl: "https://scamatrix.com/en/webioc/privacy",
} as const;

export const elktrail = {
    name: "ELKTrail by ScaMatrix",
    chromeWebStoreUrl: "https://chromewebstore.google.com/detail/epfaoiejniggbngjfdmekdhacacfgiai/",
    privacyUrl: "https://scamatrix.com/en/elktrail/privacy",
} as const;

export const nameVariants = [
    "ScaMatrix",
    "scamatrix",
    "clizSec",
    "clizsec",
    "Mark Liapustin",
    "Mark Lyapustin",
] as const;

export const canonicalSiteLinks = {
    default: "https://scamatrix.com/en",
    english: "https://scamatrix.com/en",
    spanish: "https://scamatrix.com/es",
    russian: "https://scamatrix.com/ru",
    arabic: "https://scamatrix.com/ar",
    hebrew: "https://scamatrix.com/he",
    hindi: "https://scamatrix.com/hi",
} as const;

/** Verified public profiles - reciprocal linking targets for SEO and identity. */
export const externalProfiles = [
    { name: "clizSec Portfolio", url: clizsec.canonicalEnglish },
    { name: "WebIOC (Chrome extension)", url: webioc.chromeWebStoreUrl },
    { name: "GitHub", url: "https://github.com/clizsec" },
    { name: "LinkedIn (clizSec)", url: "https://www.linkedin.com/in/clizsec" },
    { name: "X (ScaMatrix)", url: "https://x.com/ScaMatrix" },
    { name: "LinkedIn (ScaMatrix)", url: "https://www.linkedin.com/company/scamatrix/" },
    { name: "Facebook (ScaMatrix)", url: "https://www.facebook.com/scamatrix" },
] as const;

export const knowsAbout = [
    "Threat intelligence",
    "Indicators of compromise",
    "Phishing detection",
    "Malware analysis",
    "URL reputation",
    "Domain reputation",
    "IP reputation",
    "Email security",
    "Anti-phishing",
    "Security tools",
    "IOC scanning",
    "Blocklist lookup",
] as const;
